import FlowStepParamList, { MAX_HEIGHT } from '../FlowStepParamList';
import { FlowStep } from 'App/resources/Model/Flow';
import T from 'Components/Helpers/translate';
import React from 'react';

type Props = {
	step: FlowStep;
	onClick: () => void;
	onDelete: () => void;
	editable: boolean;
};

const FlowStepUpdateClient = (props: Props) => {
	return <FlowStepParamList icon="home" title={T('flow.step.updateClient')} entity="account" {...props} />;
};

export { MAX_HEIGHT };
export default FlowStepUpdateClient;
